import { ReactElement } from 'react';

import { Preset } from '../../models/toasts';
import Icon from '../Icon';

import './styles.scss';

export interface IProps {
  id: string;
  text: string;
  preset?: Preset;
  onClose?: (id: string) => void;
}

export default function Toast({
  text,
  preset = Preset.Primary,
  onClose,
  id
}: IProps): ReactElement {
  function close(): void {
    if (onClose) onClose(id);
  }

  return (
    <div className={`toast ${preset}`}>
      <div className="toast-text">{text}</div>
      <button className="toast-close-button" onClick={close}>
        <Icon className="toast-icon" icon="cross" />
      </button>
    </div>
  );
}
